import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatio, Image } from '@chakra-ui/react';
import { getImageUrlWithFallback } from '../../utils/membershipPromoBanner';

const MembershipPromoBannerImage = ({ image, currentLanguage }) => {
  if (!image) return null;
  const { display, custom_content } = image;
  if (display === 'hidden') return null;

  const imgUrl = getImageUrlWithFallback(custom_content, currentLanguage);

  if (!imgUrl) return null;

  return (
    <AspectRatio
      data-e2e-id="membership-promo-banner_image"
      width="100%"
      ratio={16 / 9}
      mb="24px"
    >
      <Image
        src={imgUrl}
        alt="membership promo banner"
        // chakra ui bug, workaround: https://github.com/chakra-ui/chakra-ui/issues/4347#issuecomment-904638065
        objectFit="contain !important"
      />
    </AspectRatio>
  );
};

MembershipPromoBannerImage.propTypes = {
  image: PropTypes.shape({
    display: PropTypes.string,
    custom_content: PropTypes.shape({
      images: PropTypes.shape({
        original: PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
      _id: PropTypes.string,
    }),
  }),
  currentLanguage: PropTypes.string,
};

export default MembershipPromoBannerImage;
